import { Alert, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ESpinner from 'components/others/Spinner';
import TitleCounter from 'components/others/TitleCounter';
import WarrantiesToolBar from './WarrantiesToolBar';
import WarrantyTable from '../WarrantyTable';
import OffWarrantyCard from '../OffWarrantyCard';
import { useWarranties } from './model';

const Warranties = () => {
    const { t } = useTranslation('Warranties');
    const state = useWarranties();
    return (
        <>
            <Row>
                <Col className="col-sticky" sm={12}>
                    <div className="w-100 d-sm-flex pt-1 justify-content-between align-items-start">
                        <div>
                            <h4 className="p-0 m-0 mb-0 me-2 text-break">{t('title')}</h4>
                            <TitleCounter />
                        </div>
                        <div className="mt-2 mt-sm-0">
                            <WarrantiesToolBar />
                        </div>
                    </div>
                </Col>
                <Col sm={12}>
                    {state.error && <Alert variant="danger">{state.error}</Alert>}
                    {state.rows === null ? (
                        state.loading ? (
                            <ESpinner />
                        ) : null
                    ) : (
                        <WarrantyTable
                            rows={state.rows}
                            loading={state.loading}
                            visible={state.visible}
                            onOpen={state.setCardId}
                            onDelete={state.deleteWarranty}
                            onArchive={state.archiveWarranty}
                            order={state.query.order}
                            desc={state.query.desc}
                            onSort={(order) =>
                                state.setQuery((q) => ({
                                    ...q,
                                    order,
                                    desc: q.order === order ? !q.desc : false,
                                }))
                            }
                        />
                    )}
                </Col>
            </Row>
            {state.cardId !== null && (
                <OffWarrantyCard
                    id={state.cardId}
                    onClose={() => state.setCardId(null)}
                    onSaved={state.refresh}
                />
            )}
        </>
    );
};

export default Warranties;
